import { watch } from 'vue'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { useUserStore } from '@/features/user/stores/user.store'

export function useAppBootstrap() {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  // Always re-fetch on auth — persisted cache is for flash prevention only
  watch(() => authStore.isAuthenticated, (isAuth) => {
    if (isAuth) {
      userStore.fetchAll()
    } else {
      userStore.$reset()
    }
  }, { immediate: true })

  return { authStore, userStore }
}
